import type { FaireProductEntity } from "../../entity_types/product";

export const casa_bosques_4: FaireProductEntity = {
  token: "casa-bosques-4",
  type: "product",
  name: "Cardamom",
  brandName: "Casa Bosques",
  imageUrl:
    "https://cdn.faire.com/fastly/66a505dfc938a93c14399d106e0c98cf441f3b5d01b31473dc2974ee2bb69bad.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=960&width=720",
  priceDollars: 8.5,
  msrpDollars: 14,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
